module.exports = __webpack_public_path__ + "media/device_event_alert.83950b0a.mp3";